/**
 * Ant Design 组件级主题配置
 * 限制: <210行
 */

import { boxShadow } from '../tokens/effects';
import { neutralColors, brandColors } from '../tokens/colors';

export const componentThemes = {
  // ======== 按钮 ========
  Button: {
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    fontSize: 16,
    fontWeight: 500,
    borderRadius: 8,
    paddingContentHorizontal: 16,
    primaryShadow: '0 2px 0 rgba(37, 99, 235, 0.1)',
    algorithm: true,
  },

  // ======== 卡片 ========
  Card: {
    borderRadiusLG: 12,
    boxShadowTertiary: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    paddingLG: 24,
    padding: 16,
    paddingSM: 12,
  },

  // ======== 输入框 ========
  Input: {
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    borderRadius: 8,
    paddingBlock: 8,
    paddingInline: 12,
    fontSize: 16,
  },

  // ======== 表格 ========
  Table: {
    borderRadiusLG: 8,
    padding: 16,
    paddingContentVerticalLG: 12,
    cellPaddingBlockMD: 12,
    cellPaddingInlineMD: 16,
    headerBg: neutralColors.gray[50],
    headerColor: neutralColors.gray[800],
    rowHoverBg: neutralColors.gray[50],
  },

  // ======== 模态框 ========
  Modal: {
    borderRadiusLG: 16,
    contentBg: '#ffffff',
    headerBg: '#ffffff',
    paddingContentHorizontalLG: 24,
    paddingMD: 24,
  },

  // ======== 标签 ========
  Tag: {
    defaultBg: neutralColors.gray[100],
    defaultColor: neutralColors.gray[700],
    borderRadiusSM: 6,
  },

  // ======== 消息提示 ========
  Message: {
    contentBg: '#ffffff',
    boxShadow: boxShadow.lg,
  },

  // ======== 通知 ========
  Notification: {
    width: 384,
    borderRadiusLG: 12,
    boxShadow: boxShadow.xl,
  },

  // ======== 选择器 ========
  Select: {
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    borderRadius: 8,
    optionPadding: '8px 12px',
  },

  // ======== 日期选择器 ========
  DatePicker: {
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    borderRadius: 8,
  },

  // ======== 开关 ========
  Switch: {
    trackHeight: 24,
    trackHeightSM: 20,
    trackMinWidth: 44,
    trackMinWidthSM: 36,
  },

  // ======== 滑块 ========
  Slider: {
    trackBg: neutralColors.gray[200],
    trackHoverBg: neutralColors.gray[300],
    railSize: 4,
    handleSize: 16,
    handleSizeHover: 18,
  },

  // ======== 进度条 ========
  Progress: {
    defaultColor: brandColors.primary.main,
    circleTextColor: neutralColors.gray[900],
    remainingColor: neutralColors.gray[200],
  },

  // ======== 分页 ========
  Pagination: {
    itemSize: 32,
    itemSizeSM: 24,
    borderRadius: 6,
  },

  // ======== 菜单 ========
  Menu: {
    itemHeight: 48,
    itemPaddingInline: 16,
    itemBorderRadius: 8,
    itemMarginBlock: 4,
    itemMarginInline: 8,
    iconSize: 18,
    iconMarginInlineEnd: 12,
    subMenuItemBorderRadius: 8,
  },

  // ======== 抽屉 ========
  Drawer: {
    zIndexPopup: 1050,
    paddingLG: 24,
  },

  // ======== 下拉菜单 ========
  Dropdown: {
    paddingBlock: 8,
    controlPaddingHorizontal: 12,
    borderRadiusLG: 8,
    boxShadowSecondary: boxShadow.lg,
  },

  // ======== 提示框 ========
  Tooltip: {
    borderRadiusOuter: 8,
    boxShadowSecondary: boxShadow.md,
  },

  // ======== 气泡卡片 ========
  Popover: {
    boxShadowSecondary: boxShadow.lg,
    borderRadiusLG: 12,
  },

  // ======== 标签页 ========
  Tabs: {
    cardBg: neutralColors.gray[50],
    cardGutter: 4,
    horizontalItemPadding: '12px 16px',
    horizontalItemPaddingLG: '16px 24px',
    horizontalItemPaddingSM: '8px 12px',
    itemActiveColor: brandColors.primary.main,
    itemHoverColor: brandColors.primary.light,
    itemSelectedColor: brandColors.primary.main,
    inkBarColor: brandColors.primary.main,
    cardHeight: 48,
  },

  // ======== 折叠面板 ========
  Collapse: {
    headerPadding: '12px 16px',
    contentPadding: '16px',
    borderRadiusLG: 8,
  },

  // ======== 警告提示 ========
  Alert: {
    borderRadiusLG: 8,
    withDescriptionPadding: '16px 20px',
  },

  // ======== 徽标 ========
  Badge: {
    dotSize: 8,
    textFontSize: 12,
    textFontSizeSM: 10,
    textFontWeight: 600,
  },

  // ======== 头像 ========
  Avatar: {
    containerSize: 40,
    containerSizeLG: 48,
    containerSizeSM: 32,
    borderRadius: 8,
  },

  // ======== 骨架屏 ========
  Skeleton: {
    borderRadiusSM: 4,
    titleHeight: 16,
    paragraphMarginTop: 28,
  },
};

